import React from "react";
import PackageCard from "../../components/PackageCard/PackageCard";

export default function StarPackages({ prices, packages, loadingPkg, pkgCount, labels, onActivate }) {
  return (
    <div className="plan-packages-grid">
      {Array.from({ length: pkgCount }, (_, i) => {
        const isActive = packages ? packages.a[i] : false;
        const prevActive = i === 0 ? true : (packages ? packages.a[i - 1] : false);
        const canActivate = !isActive && prevActive;

        return (
          <PackageCard
            key={i}
            index={i}
            label={labels[i]}
            price={prices[i]}
            isActive={isActive}
            canActivate={canActivate}
            earned={packages ? packages.e[i] : undefined}
            holdBal={packages && packages.h ? packages.h[i] : undefined}
            onActivate={onActivate}
            loading={loadingPkg === i}
          />
        );
      })}
    </div>
  );
}
